/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_LatvianInputs */



/**
* | output |
* | --- |
* | "Latvian" |
*
* @param {Speechmatics_Target_Language_LatvianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_latvian = /** @type {((inputs?: Speechmatics_Target_Language_LatvianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_LatvianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Letton")
	if (locale === "de") return /** @type {LocalizedString} */ ("lettisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("lettone")
	if (locale === "ru") return /** @type {LocalizedString} */ ("латышский")
	if (locale === "es") return /** @type {LocalizedString} */ ("letón")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拉脱维亚语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ラトビア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लात्वीयावासी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("letão")
	return /** @type {LocalizedString} */ ("Latvian")
});